import { c as _c } from "react/compiler-runtime";
import { CommunityMemberMinimal } from "@/entities/IProfile";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
export default function GroupCreateIdentitiesSearchItem(t0) {
  const $ = _c(23);
  const {
    item,
    selected,
    onProfileSelect
  } = t0;
  const title = item.handle ?? item.display;
  let t1;
  if ($[0] !== item || $[1] !== onProfileSelect) {
    t1 = () => onProfileSelect(item);
    $[0] = item;
    $[1] = onProfileSelect;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onProfileClick = t1;
  let t2;
  if ($[3] !== item.pfp) {
    t2 = item.pfp && <div className="tw-h-6 tw-w-6 tw-rounded-md tw-overflow-hidden tw-ring-1 tw-ring-inset tw-ring-white/10 tw-bg-iron-900"><div className="tw-h-full tw-w-full tw-max-w-full"><div className="tw-h-full tw-text-center tw-flex tw-items-center tw-justify-center"><img src={getScaledImageUri(item.pfp, ImageScale.W_AUTO_H_50)} alt="Network Table Profile Picture" className="tw-bg-transparent tw-max-w-full tw-max-h-full tw-h-auto tw-w-auto tw-mx-auto tw-object-contain" /></div></div></div>;
    $[3] = item.pfp;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== title) {
    t3 = <p className="tw-mb-0 tw-text-sm tw-font-medium tw-text-white tw-truncate tw-whitespace-nowrap">{title}</p>;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== item.display) {
    t4 = <p className="tw-mb-0 tw-text-xs tw-font-medium tw-text-iron-400 tw-truncate tw-whitespace-nowrap">{item.display}</p>;
    $[7] = item.display;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="tw-w-[12rem] tw-truncate">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t5) {
    t6 = <div className="tw-flex tw-space-x-2 tw-items-center">{t2}{t5}</div>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== selected) {
    t7 = selected && <svg className="tw-flex-shrink-0 tw-h-5 tw-w-5 tw-text-primary-300 tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[15] = selected;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className="tw-w-full tw-flex tw-justify-between tw-items-center">{t6}{t7}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== onProfileClick || $[21] !== t8) {
    t9 = <li className="tw-h-full"><button type="button" className="hover:tw-bg-iron-700 tw-py-2 tw-w-full tw-h-full tw-bg-transparent tw-border-none tw-text-left tw-flex tw-items-center tw-justify-between tw-text-white tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-px-2 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out" onClick={onProfileClick}>{t8}</button></li>;
    $[20] = onProfileClick;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}